import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/css/style.css";
import ArgonDashboard from "./argon-dashboard";
// import SuccessAlert from './components/SuccessAlert.vue';

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
store.dispatch('getUser'); 
appInstance.mount("#app");
// appcomponent('SuccessAlert', SuccessAlert);
